import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { ReviewPlanInformationForm } from '../forms'
import { useHistory } from 'react-router-dom'
import { Path, AccountAudience } from 'config/portal'
import * as apiActions from 'api-actions'
import { selectors as globalSelectors } from 'global-reducer'
import { selectors as selectors } from '../reducer'
import { ComponentFailure } from 'components'

const propTypes = {
  currentUser: Types.user.isRequired,
  addendumServicesAgreementHash: PropTypes.object.isRequired,
  fetchServicesAgreementDetails: PropTypes.func.isRequired,
}

const defaultProps = {}

function ReviewPlanInformationView({
  currentUser,
  addendumServicesAgreementHash,
  fetchServicesAgreementDetails,
}) {
  const history = useHistory()
  const [error, setError] = useState(false)
  const [planAgreementDetails, setPlanAgreementsDetails] = useState({})
  const isPlanFiduciary =
    currentUser.accountAudience === AccountAudience.PLAN_FIDUCIARY

  const addendumAgreement = addendumServicesAgreementHash
  const servicesAgreementId = addendumAgreement?.value

  useEffect(() => {
    async function getPlanAgreementDetails() {
      try {
        const response = await fetchServicesAgreementDetails(
          servicesAgreementId
        )
        setPlanAgreementsDetails(response)
      } catch {
        setError(true)
      }
    }
    if (!isPlanFiduciary) getPlanAgreementDetails()
  }, [servicesAgreementId])

  const planSponsorCompanyDetails = planAgreementDetails
    ? planAgreementDetails.planSponsorCompany
    : null
  const planSponsorContactDetails = planAgreementDetails
    ? planAgreementDetails.planSponsorContact
    : null

  if (error) return <ComponentFailure />

  const handleSubmit = async () => {
    history.push({
      pathname: Path.REVIEW_AND_SUBMIT_NOTIFICATIONS_ADDENDUM,
      state: {
        search: history.location.state?.search,
      },
    })
  }

  return (
    <div className="card full-height complete-search-agreement-view">
      <div className="complete-search-agreement-form-container">
        <div className="form-masthead">
          <h2>Confirm your plan sponsor contact information</h2>
          <p className="form-masthead-text">
            Check that your plan sponsor's contact information is correct.
          </p>
        </div>
        <div className="form-section">
          <ReviewPlanInformationForm
            initialValues={{
              companyDetails: planSponsorCompanyDetails,
              contactDetails: planSponsorContactDetails,
            }}
            onSubmit={handleSubmit}
            companyDetails={planSponsorCompanyDetails}
            contactDetails={planSponsorContactDetails}
          />
        </div>
      </div>
    </div>
  )
}

ReviewPlanInformationView.propTypes = propTypes
ReviewPlanInformationView.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    currentUser: globalSelectors.currentUser(state),
    addendumServicesAgreementHash:
      selectors.addendumServicesAgreementHash(state),
  }
}

const mapDispatchToProps = {
  fetchServicesAgreementDetails: apiActions.fetchServicesAgreementDetails,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ReviewPlanInformationView)
)
